import flex from './flex'

const flexColumn = {...flex, flexDirection: 'column' as 'column'}
export default flexColumn
